import * as React from 'react'
import { licenseInfo } from '@saturn/License/LicenseClient';
import { JavascriptMessage } from '@framework/Signum.Entities';
import * as AppContext from '@framework/AppContext';
import * as AuthClient from '@extensions/Authorization/AuthClient'

export default function Home(p: {}) {

  const [loaded, setLoaded] = React.useState<boolean>(false);
  const ToolbarMainRenderer = React.lazy(() => import('@extensions/Toolbar/Templates/ToolbarMainRenderer'));

  React.useEffect(() => {
    if (AuthClient.currentUser()) {
      import("@extensions/Dashboard/DashboardClient")
        .then(DashboardClient => DashboardClient.API.home())
        .then(h => {
          if (h)
            AppContext.history.push(`~/dashboard/${h.id}`);
          else
            setLoaded(true);
        });
    }
    else //Dashboard
      setLoaded(true);
  }, []);


  if (!loaded)
    return null;

  return (
    <div>
      <br />
      <div className="jumbotron">
        <h1 className="display-5"><strong>{licenseInfo.productName}</strong></h1><h1 className="display-7">Application development and BPMS platform</h1>
        <hr />
        <br />
        <br />
        {AppContext.currentUser && <React.Suspense fallback={JavascriptMessage.loading.niceToString()}><ToolbarMainRenderer /></React.Suspense>}
        <p className="font-weight-light">
          To learn more visit <a href={licenseInfo.companyURL} title={licenseInfo.companyName}>{licenseInfo.companyURL.replace(/(^\w+:|^)\/\//, '').trimEnd()}</a>.
        </p>
      </div>
    </div>
  );
}
